/**
 * 화면 유형
 */
export enum PageType {
    NONE = 'NA',
    MAIN_SCREEN = 'MS', //메인 화면
    TAB = 'TB', //탭 화면
    FULL_POPUP = 'FP', //전체 팝업
    DRAWER = 'DR', //바텀시트
    DIALOG = 'DG', //부분 팝업
}
